<template>
  <div class="_form">
    <b-row class="m-0">
      <!-- Form-->
      <b-col lg="12" class="d-flex align-items-center px-2 p-lg-5 mt-2">
        <b-col sm="12" md="8" lg="6" class="px-xl-2 mx-auto">
          <b-card>
            <b-card-title class="mb-1 font-weight-bold text-center" title-tag="h2">
              Olá, bem-vindo(a)!
            </b-card-title>
            <b-card-text class="mb-2 text-center" v-if="!generalOrientation">
              Formulário de Relato<br /><br/>
            </b-card-text>
            <b-card-text class="mb-2" v-if="generalOrientation" v-html-safe="generalOrientation">
            </b-card-text>
            <!-- form -->
            <validation-observer ref="requestForm">
              <b-form class="mb-1 mt-2" @submit.prevent="send" @keydown.enter.stop>
                <!-- isIdentify -->
                <b-form-group
                  :label="$t('reporting_channel.form.field01')"
                  label-for="isIdentify">
                  <b-form-radio-group
                    id="isIdentify"
                    name="isIdentify"
                    v-model="form_data.isIdentify"
                    @change="updateIsIdentify">
                    <b-form-radio :value="false">{{$t('no')}}</b-form-radio>
                    <b-form-radio :value="true">{{$t('yes')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <!-- Person data -->
                <b-form-group
                  :label="$t('reporting_channel.form.field01_01')"
                  label-for="field01_01" v-if="form_data.isIdentify">
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('field01_01')"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                      <b-form-input
                        id="field01_01"
                        name="personName"
                        v-model="form_data.person.name"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  :label="$t('reporting_channel.form.field01_02')"
                  label-for="field01_02" v-if="form_data.isIdentify">
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('field01_02')"
                      :custom-messages="{required: $t('messages.field_requerid'), cpf: $t('messages.field_invalid')}"
                      rules="required|cpf">
                      <b-form-input
                        id="field01_02"
                        name="personDocument"
                        v-model="form_data.person.document"
                        v-mask="'###.###.###-##'"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  :label="$t('reporting_channel.form.field01_03')"
                  label-for="field01_03" v-if="form_data.isIdentify">
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('field01_03')"
                      :custom-messages="{required: $t('messages.field_requerid'), email: $t('messages.field_invalid')}"
                      rules="required|email">
                      <b-form-input
                        id="field01_03"
                        name="field01_03"
                        v-model="form_data.person.email"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  :label="$t('reporting_channel.form.field01_04')"
                  :custom-messages="{required: $t('messages.field_requerid')}"
                  label-for="field01_04" v-if="form_data.isIdentify">
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('field01_04')"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                      <b-form-input
                        id="field01_04"
                        name="field01_04"
                        v-model="form_data.person.phone"
                        v-mask="['(##)####-####', '(##)#####-####']"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- End Person data-->
                <!-- report_channel_exclusive -->
                <b-form-group
                  :label="$t('reporting_channel.important')">
                  <small class="text-muted">
                    <p style="white-space: pre-line">
                      {{$t('reporting_channel.report_channel_exclusive', [legalEntiyName])}}
                    </p>
                  </small>
                </b-form-group>
                <!-- customerRelationship -->
                <b-form-group
                  :label="$t('reporting_channel.form.field02_', [[legalEntiyName]])"
                  label-for="field02">
                  <validation-provider
                      #default="{ errors }"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                        <b-form-radio-group
                          id="field02"
                          :options="customerRelationshipList"
                          value-field="id"
                          text-field="name"
                          v-model="customerRelationshipId"
                          name="field02"
                          stacked/>
                          <b-form-input v-if="enableCustomerRelationshipOther"
                            id="customerRelationshipOther"
                            v-model="form_data.customerRelationshipOther"
                            :state="errors.length > 0 ? false:null"
                            class="required mt-1"
                            name="customerRelationshipOther"/>
                          <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- typeReporting -->
                <b-form-group
                  :label="$t('reporting_channel.form.field03')"
                  label-for="typeReporting">
                  <validation-provider
                      #default="{ errors }"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                      <v-select v-model="form_data.typeReporting" :options="typeReportingList" label="name" class="required-select" ref="select-typeReporting">
                      </v-select>
                      <b-form-input v-if="enableTypeReportingOther"
                        id="typeReportingOther"
                        v-model="form_data.typeReportingOther"
                        :state="errors.length > 0 ? false:null"
                        class="required mt-1"
                        name="typeReportingOther"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <!-- Unity -->
                <b-form-group
                  :label="$t('reporting_channel.form.field04')"
                  label-for="unity">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <v-select v-model="legalEntity" :options="listLegal" label="name" class="required-select" ref="select-legal-entity">
                      <div slot="no-options">{{$t('msg_none')}}</div>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Area -->
                <b-form-group
                  :label="$t('reporting_channel.form.field05')"
                  label-for="area">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <b-form-input
                      id="area"
                      v-model="area"
                      :state="errors.length > 0 ? false:null"
                      @keypress.13.prevent
                      class="required"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- knowFact -->
                <b-form-group
                  :label="$t('reporting_channel.form.field06')"
                  label-for="knowFact">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <v-select v-model="form_data.knowFact" :options="knowFactList" label="name" class="required-select" ref="select-knowFact">
                      <div slot="no-options">{{$t('msg_none')}}</div>
                    </v-select>
                    <b-form-input v-if="enableKnowFactOther"
                        id="customerRelationshipOther"
                        v-model="form_data.knowFactOther"
                        :state="errors.length > 0 ? false:null"
                        class="required mt-1"
                        name="knowFactOther"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- statusOfReport -->
                <b-form-group
                  :label="$t('reporting_channel.form.field07')"
                  label-for="field07">
                  <validation-provider
                      #default="{ errors }"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                        <b-form-radio-group
                          id="field07"
                          :options="statusOfReportList"
                          value-field="id"
                          text-field="name"
                          v-model="statusOfReportId"
                          name="field07"
                          stacked/>
                          <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- whatReport -->
                <b-form-group
                  :label="$t('reporting_channel.form.field08')"
                  label-for="whatReport">
                  <small class="text-muted">
                    {{$t('reporting_channel.form.field08_01')}}
                    <p style="white-space: pre-line">
                      {{$t('reporting_channel.form.field08_02')}}
                    </p>
                  </small>
                  <b-form-textarea
                    id="whatReport"
                    v-model="form_data.whatReport"
                    :state="form_data.whatReport.length >= 20"
                    :placeholder="$t('form_min_caracter_', [20])"
                    rows="4"/>
                </b-form-group>
                <!-- keepsHappening -->
                <b-form-group
                  :label="$t('reporting_channel.form.field09')"
                  label-for="keepsHappening">
                  <validation-provider
                      #default="{ errors }"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                      <b-form-input
                        id="keepsHappening"
                        v-model="form_data.keepsHappening"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- whenAndWho -->
                <b-form-group
                  :label="$t('reporting_channel.form.field10')"
                  label-for="whenAndWho">
                  <validation-provider
                      #default="{ errors }"
                      :custom-messages="{required: $t('messages.field_requerid')}"
                      rules="required">
                      <b-form-input
                        id="whenAndWho"
                        v-model="form_data.whenAndWho"
                        :state="errors.length > 0 ? false:null"
                        @keypress.13.prevent
                        class="required"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- otherPeople -->
                <b-form-group
                  :label="$t('reporting_channel.form.field11')"
                  label-for="otherPeople">
                  <b-form-input
                    id="otherPeople"
                    v-model="form_data.otherPeople"
                    @keypress.13.prevent/>
                </b-form-group>
                <!-- thereEvidence -->
                <b-form-group
                  :label="$t('reporting_channel.form.field12')"
                  label-for="whatReport">
                  <small class="text-muted">
                    <p style="white-space: pre-line">
                      {{$t('reporting_channel.form.field12_01')}}
                    </p>
                    <p style="white-space: pre-line">
                      {{$t('reporting_channel.form.field12_02')}}
                    </p>
                  </small>
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <b-form-textarea
                      id="thereEvidence"
                      v-model="form_data.thereEvidence"
                      :state="form_data.thereEvidence.length >= 20"
                      :placeholder="$t('form_min_caracter_', [20])"
                      rows="4"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- siteProfile -->
                <b-form-group
                  :label="$t('reporting_channel.form.field13')"
                  label-for="siteProfile">
                  <b-form-input
                    id="siteProfile"
                    v-model="form_data.siteProfile"
                    @keypress.13.prevent/>
                </b-form-group>

                <b-form-group
                  :label="$t('reporting_channel.form.field14')"
                  label-for="whyReporting">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <b-form-input
                      id="whyReporting"
                      v-model="form_data.whyReporting"
                      :state="errors.length > 0 ? false:null"
                      @keypress.13.prevent
                      class="required"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- howInvestigate -->
                <b-form-group
                  :label="$t('reporting_channel.form.field15')"
                  label-for="howInvestigate">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <b-form-input
                      id="howInvestigate"
                      v-model="form_data.howInvestigate"
                      :state="errors.length > 0 ? false:null"
                      @keypress.13.prevent
                      class="required"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- employeesAware -->
                <b-form-group
                  :label="$t('reporting_channel.form.field16')"
                  label-for="employeesAware">
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{required: $t('messages.field_requerid')}"
                    rules="required">
                    <b-form-radio-group
                      id="employeesAware"
                      v-model="form_data.employeesAware"
                      name="employeesAware">
                      <b-form-radio :value="false">{{$t('no')}}</b-form-radio>
                      <b-form-radio :value="true">{{$t('yes')}}</b-form-radio>
                    </b-form-radio-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  :label="$t('reporting_channel.form.field17')"
                  label-for="financialValue">
                  <b-form-input
                    id="financialValue"
                    v-model="form_data.financialValue"
                    @keypress.13.prevent/>
                </b-form-group>
                <!-- Input Files-->
                <div class="vx-row pt-2 justify-content-center">
                  <div class="vx-col">
                    <vue-dropzone
                      id="upload"
                      ref="fileUploadZone"
                      v-on:vdropzone-success="successSendFormWithFile"
                      v-on:vdropzone-sending="sendFormWithFile"
                      v-on:vdropzone-error="errorSendFormFile"
                      v-on:vdropzone-file-added="added"
                      v-on:vdropzone-queue-complete="complete"
                      :use-font-awesome="true"
                      :options="dropzoneOptions"
                      :use-custom-dropzone-options="true"
                      :useCustomSlot="true"
                      @vdropzone-file-added="fileAdded">

                      <div class="dropzone-custom-content">
                        <!--<h3 class="dropzone-custom-title">Arraste e solte para enviar o arquivo!</h3>
                        <div class="subtitle">...ou selecione um arquivo do seu computador.</div>
                        -->
                         Arraste e solte para enviar um arquivo
                        <p class="separator"><span class="separator-span"> ou </span></p>
                        <b-button type="button" class="btn waves-effect outline-primary" variant="outline-secondary">Selecionar</b-button>
                      </div>

                    </vue-dropzone>
                  </div>
                </div>

                <div class="vx-row pt-2">
                  <div class="vx-col w-full">
                    Ao preencher o formulário, você concorda que a SECURAMDATA salve e envie as informações
                    prestadas à empresa/organização contratante de seus serviços,
                    possibilitando que medidas sejam tomadas a partir da análise do conteúdo de suas respostas.
                    Para mais informações sobre a proteção de dados e os direitos do usuário,
                    acesse o <b-link href="https://securamdata.com/portal-de-privacidade" target="_brank">Portal de Privacidade</b-link>.
                  </div>
                </div>
                 <!-- -->
                <div class="vx-row pt-2">
                  <div class="vx-col w-full">
                    <b-form-checkbox v-model="aware">Li e concordo com o termo acima</b-form-checkbox>
                  </div>
                </div>
                <!-- submit buttons -->
                <div class="vx-row pt-2">
                  <div class="vx-col w-full">
                      <b-button
                        :disabled="!validateForm"
                        type="submit"
                        variant="primary"
                        class="waves-effect float-right">
                        Enviar
                      </b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
            <!-- end form-->
            <b-card-footer class="text-right">
              <small class="text-muted">Desenvolvido por:</small> &nbsp;&nbsp;
              <b-link href="https://securamdata.com" target="_brank">securamdata.com</b-link>
            </b-card-footer>
          </b-card>
        </b-col> <!-- b-col-->
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import standard from '@/services/standard'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import { clearObjectData } from '@/util/Util'


import ReportingChannelFormService from '@/services/api/reporting-channel/ReportingChannelFormService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Datepicker,
    vueDropzone: vue2Dropzone,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      form_data: {
        isIdentify: false,
        person: {
          name: '',
          document: '',
          email: '',
          phone: '',
        },
        customerRelationship: {},
        typeReporting: {},
        statusOfReport: {},
        knowFact: null,
        whatReport: '',
        whenAndWho: '',
        otherPeople: '',
        thereEvidence: '',
        siteProfile: '',
        whyReporting: '',
        howInvestigate: '',
        employeesAware: null,
        financialValue: '',
      },
      customerRelationshipId: null, //Aux to get object in list customerRelationship
      statusOfReportId: null, //Aux to get object in list statusOfReportList
      legalEntiyName: '',
      legalEntity: '',
      area: '',
      generalOrientation: '',
      legalEntityList : [],
      aware: false,
      //Lists
      customerRelationshipList: [],
      typeReportingList: [],
      knowFactList: [],
      statusOfReportList: [],
      format: 'dd/MM/yyyy',
      ptBR,
      required,
      email,
      //Services
      services: {
        form : null,
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/reporting_channel_form`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        thumbnailWidth: 200,
        maxFiles: 1,
        createImageThumbnails: true,
        dictRemoveFile:"Remover arquivo",
      },
    }
  },
  watch: {

  },
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.legalEntity)
          && this.validateIsIdentify()
          && this.aware
      )
    },
    listLegal(){
       this.legalEntityList.push({
        id: null,
        name: "Outras",
        trading_name: "Outras"
      })
      return this.legalEntityList
    },
    customerRelationshipSelected(){ //To get object full (id and name)
      if(this.customerRelationshipId){
        return this.customerRelationshipList.find(o => o.id === this.customerRelationshipId);
      }
      return null
    },
    statusOfReportSelected(){ //To get object full (id and name)
      if(this.statusOfReportId){
        return this.statusOfReportList.find(o => o.id === this.statusOfReportId);
      }
      return null
    },
    enableCustomerRelationshipOther(){
      return (this.customerRelationshipSelected
                && this.customerRelationshipSelected.id
                && parseInt(this.customerRelationshipSelected.id) === 100 ) ? true : false
    },
    enableTypeReportingOther(){
      return (this.form_data.typeReporting
                && this.form_data.typeReporting.id
                && parseInt(this.form_data.typeReporting.id) === 100 ) ? true : false
    },
    enableKnowFactOther(){
      return (this.form_data.knowFact
                && this.form_data.knowFact.id
                && parseInt(this.form_data.knowFact.id) === 100 ) ? true : false
    }
  },
  methods: {
    validateIsIdentify() {
      if(this.form_data.isIdentify){
        return !this.isEmpty(this.form_data.person.name)
              && !this.isEmpty(this.form_data.person.document)
              && !this.isEmpty(this.form_data.person.email)
              && !this.isEmpty(this.form_data.person.phone)
      }else{
        return true //True to validad is identify
      }
    },
    updateIsIdentify(value){
      if(!value){ //Not... clear person data
        this.form_data.person.name = ''
        this.form_data.person.document = ''
        this.form_data.person.email = ''
        this.form_data.person.phone = ''
      }
    },
    fileAdded(file){
      //console.log(file)
      //this.fileUpload = file;
    },
    errorSendFormFile(...a) {
      console.log('error: ', ...a)
      this.$vs.loading.close()
      this.notifyError(this.$vs, 'Não foi possível enviar esse formulário.', 3000)
    },
    added(...a) {
      console.log('added: ', ...a)
    },
    send() {
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.clearErrors(this.$refs.requestForm)
          this.$vs.loading()

          const lengthFile = this.$refs.fileUploadZone.getQueuedFiles().length
          if(lengthFile > 0){
            this.$refs.fileUploadZone.processQueue()
          }else{
            this.sendForm();
          }
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {console.log('error: ', error)})
    },
    sendForm(){
      const params = this.getDataFields()
      //console.log(params)
      this.$vs.loading()
      this.services.form.createOrUpdate(params).then(
        data => {
          this.successSend(data)
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível enviar esse formulário.', 3000)
        }
      )
    },
    sendFormWithFile(file, xhr, formData){

      let data = _.transform(this.getDataFields(), (form, value, field) => {
        if (this._.isArray(value)) {
          value.forEach((item) => {
            formData.append(`${field}[]`, item)
          })
        } else if(this._.isObject(value)){
          this.buildFormData(formData, value, field)
        }else{
          formData.append(field, value);
        }
      }, new FormData())


      console.log('our form data is!', formData)
      //console.log(formData);
    },
    buildFormData(formData, data, parentKey) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
          Object.keys(data).forEach(key => {
            this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
          });
        } else {
          const value = data == null ? '' : data;

          formData.append(parentKey, value);
        }
      },
    successSendFormWithFile(file, data){
      this.successSend(data)
      //remove file trash
      this.$refs.fileUploadZone.removeAllFiles()
    },
    successSend(data){
      this.sucessAlertPrococol(data);
      this.clearFields()
      this.clearErrors(this.$refs.requestForm)
      this.$vs.loading.close()
    },
    sucessAlertPrococol(data){
      //this.notifySuccess(this.$vs, 'Formulário enviado com sucesso!', 3000)
      let msg = `Suas informações foram registradas com sucesso! Protocolo gerado: ${data.protocol_number}`

      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Procotolo',
        acceptText: 'ok',
        text: msg,
        accept: this.clearFields,
      })
    },
    getDataFields(){
      this.form_data.customerRelationship = this.customerRelationshipSelected
      this.form_data.statusOfReport = this.statusOfReportSelected
      const params = {
              data_encrypt: this.param_encrypt, //Get from URl
              legal_entity_id: _.get(this.legalEntity,'id'),
              area: this.area,
              aware: this.aware,
              form_data: this.form_data
          }

      return params;
    },
    clearFields() {
      this.legalEntity = ''
      this.area = ''
      clearObjectData(this.form_data)
      this.form_data.isIdentify = false
      this.form_data.person.name = ''
      this.form_data.person.document = ''
      this.form_data.person.email = ''
      this.form_data.person.phone = ''
      this.form_data.knowFact = null
      this.aware = false
      this.customerRelationshipId = null
      this.form_data.customerRelationship= {}
      this.form_data.typeReporting = {}
      this.statusOfReportId = null
      this.form_data.statusOfReport= {}
      this.$nextTick( () => {this.clearErrors(this.$validator)})

    },
    errorAlertFormValidaded(){
      const firstField = this.$el.querySelector('.is-invalid')
      if(firstField){
        firstField.scrollIntoView()
      }
      this.notifyWarning(this.$vs, this.$t('messages.form_field_invalid'), 3000)
    },
    updateCustomerRelationship(text, value) {
      this.$emit('input', { id: value, name: text })
    },
  },
  mounted() {
    //console.log(this.param_encrypt)
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.form = ReportingChannelFormService.build(this.$vs)

    promisses.push(
      this.services.form.getListLegalEntity(this.param_encrypt).then(
        data => {
          this.legalEntityList = _.get(data,'list')
          this.generalOrientation = _.get(data,'header')
          this.legalEntiyName = _.get(data,'legalEntiyName')
        },
        error => {}
      ).finally(() => {this.$vs.loading.close()})
    )

    //Lists
    promisses.push(
      this.services.form.getCustomerRelationshipList().then(
        data => {
          this.customerRelationshipList = data
        },
        error => {}
      ).finally(() => {this.$vs.loading.close()})
    )

    promisses.push(
      this.services.form.getTypeReportingList().then(
        data => {
          this.typeReportingList = data
        },
        error => {}
      ).finally(() => {this.$vs.loading.close()})
    )

    promisses.push(
      this.services.form.getKnowFactList().then(
        data => {
          this.knowFactList = data
        },
        error => {}
      ).finally(() => {this.$vs.loading.close()})
    )

    promisses.push(
      this.services.form.getStatusOfReportList().then(
        data => {
          this.statusOfReportList = data
        },
        error => {}
      ).finally(() => {this.$vs.loading.close()})
    )

    //
    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  }
}
</script>

<style lang="scss" scoped>
</style>

